import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import IconChat from '../../Icons/IconChat';

type Props = {
  onChange: (value: number) => void;
  years: number[];
};

const RevistasFilter: FC<Props> = ({ onChange, years }) => {
  const { t } = useTranslation();
  const [value, setValue] = useState(
    parseInt(sessionStorage.getItem('yearRevistas') as string, 10),
  );

  const handleChange = (e: React.FormEvent<HTMLSelectElement>) => {
    const selectedId = e.currentTarget.value;
    setValue(Number(selectedId));
    onChange(Number(selectedId));
    sessionStorage.setItem('yearRevistas', selectedId);
  };
  return (
    <>
      <div className="revista__filtro">
        <p>{t('revistas.labelSelectYear')}</p>
        <div className="form-group select-wrapper">
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label htmlFor="publicacion-anno" className="hidden">
            Año
          </label>
          <div className="form-control-block">
            <select
              className="form-control"
              id="publicacion-anno"
              value={value}
              onChange={(e) => handleChange(e)}
            >
              {years &&
                years.map((y) => (
                  <option key={y} value={y}>
                    {y}
                  </option>
                ))}
            </select>
            <div className="icon icon-small">
              <IconChat />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RevistasFilter;
